import requests from '../shared/agent'

const BooksService = {
  listAll: async () => {
    return await requests.get('/books')
  },
  create: async (body) => {
    return await requests.post('/books', body)
  },
  getById: async (id) => {
    return await requests.get(`/books/${id}`)
  },
  update: async (id, body) => {
    return await requests.patch(`/books/${id}`, body)
  },
  delete: async (id) => {
    await requests.del(`/books/${id}`)
    return await requests.del(`/books/${id}/delete`)
  },
  getStatistics: async (query) => {
    return await requests.get(`/books/access?${query}`)
  }
}

export default BooksService
